import { render, staticRenderFns } from "./table2.vue?vue&type=template&id=1a9ba0fb"
import script from "./table2.vue?vue&type=script&lang=js"
export * from "./table2.vue?vue&type=script&lang=js"
import style0 from "./table2.vue?vue&type=style&index=0&id=1a9ba0fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports